import React from 'react';
import PropTypes from 'prop-types';

import {Typography} from 'views/components';
import {CheckCircleOutline as CheckCircleOutlineIcon} from 'views/icons';
import {Translate} from 'views/module';

import TimelineCard from './TimelineCard';

import {formatEventDateTime} from '../dateTime';

const ShiftConfirmed = (props) => {
  const {confirmation, caregiverData, eventTimezone} = props;

  const timeString = formatEventDateTime(confirmation.createdAt, eventTimezone);
  return (
    <TimelineCard
      timeString={timeString}
      icon={CheckCircleOutlineIcon}
      iconColor="#1a73e8"
      timeBg="#e0e0e0"
      title={<Translate expression='schedule.eventDetail.EventTimelineSection.ShiftConfirmed.Title' />}
    >
      <Typography variant="body2" color="text.secondary">
        <Translate
          expression='schedule.eventDetail.EventTimelineSection.ShiftConfirmed.Description'
          substitute={{caregiverName: caregiverData.caregiverDetail.caregiverName}}
        />
      </Typography>
    </TimelineCard>
  );
};

ShiftConfirmed.propTypes = {
  confirmation: PropTypes.shape({
    createdAt: PropTypes.string.isRequired,
  }).isRequired,
  caregiverData: PropTypes.shape({
    caregiverDetail: PropTypes.shape({
      caregiverName: PropTypes.string,
    }),
  }).isRequired,
  eventTimezone: PropTypes.string.isRequired,
};

export default ShiftConfirmed;
